import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_77: FaireProductEntity = {
  token: "legacy_prod_abbott-77",
  type: "product",
  name: "Large Wild Forest Animals Napkins, 20 Pack",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/0b5e868beb7021fbe09e0832da1ceedd25bca64943c1836ed30cd3672de1540a.jpeg",
  priceDollars: 12,
  subcategory: "Tableware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_party-supplies"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
